module.exports = __webpack_public_path__ + "img/hero_text.4d360f1e.svg";